<template lang="pug">
  .wrap
    VRuntimeTemplate.textcontent(:template="article.content")

</template>
<script>
import VRuntimeTemplate from 'v-runtime-template'
import Imagen from '@/components/Imagen'
import VideoPlayer from '@/components/VideoPlayer'

export default {
  components: {
    VRuntimeTemplate,
    Imagen,
    VideoPlayer,
  },
  props: {
    article: Object,
    contentType: {
      type: String,
      default: 'article'
    }
  },
  data() {
    return {
      loading: false
    }
  }
}
</script>
<style lang="scss">
  .textcontent{
    p{
      max-width: $maxwidth;
      margin-left: auto;
      margin-right: auto;
      padding-left: 1rem;
      padding-right: 1rem;
      @media (max-width: 800px){
        max-width: 100%;
      }
      &:first-child{
        text-indent: 0;
        &:first-letter{
          // color: #e4a612;
          float: left;
          text-transform: uppercase;
          font-weight: 900;
          font-size: 7.7rem;
          text-transform: uppercase;
          line-height: 5.4rem;
          padding-top: 4px;
          padding-right: 8px;
          margin-left: -6px;
          font-family: 'col', sans-serif;
        }
      }
    }
    figure{
      max-width: $overwidth;
      margin-left: auto;
      margin-right: auto;
    }
  }
  .text{
    position: relative;
    z-index: 2;
    padding: 1px 0;
    color: white;
  }

  .block{
    .image{
      text-align: center;
      max-width: $overwidth;
      margin: 0 auto;
      @media (max-width: 800px){
        max-width: 100%;
      }
      img{
        display: block;
        max-width: 100%;
        margin: 0 auto;
      }
      figcaption{
        padding: 2px 0;
        font-family: 'Open Sans', sans-serif;
        font-size: 11px;
        letter-spacing: 0.5px;
        // text-transform: uppercase;
        margin: 0;
        color: #ddd;
        &::before{
          content: "\25B2";
          display: inline-block;
          margin-right: 4px;
          color: #ddd;
        }
      }
    }
  }

  .block{
    .audio{
      max-width: $overwidth;
      @media (max-width: 800px){
        max-width: 100%;
      }
      margin: 2rem auto;
      background-color: lighten(black, 20%);
      padding: 2rem;
      audio{
        margin: 0 auto;
        display: block;
      }
      figcaption{
        font-size: 1.8rem;
        padding: 2rem;
      }
    }
    blockquote{
      background-color: transparent;
      color: white;
      border-left: 3px solid white;
      padding-left: 2rem;
      font-size: 2rem;
    }
    .quote{
      max-width: $overwidth;
      @media (max-width: 800px){
        max-width: 100%;
      }
      margin: 2rem auto;
      background-color: lighten(black, 20%);
      padding: 2rem;
      audio{
        margin: 0 auto;
        display: block;
      }
      figcaption{
        font-size: 1.8rem;
        padding: 2rem;
      }
    }
  }



  .block {
    .videohtml{
      max-width: $overwidth;
      @media (max-width: 800px){
        max-width: 100%;
      }
      margin: 0 auto;
    }
    .videowrap{
      position: relative;
      padding-top: 56.25%;
      padding-bottom: 0;
      height: 0;
      iframe{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  }

  .content{
    padding: 0 1rem;
    max-width: 100vw;
    .block{
      margin-top: 2rem;
      margin-bottom: 2rem;
      p, h2, h3, h4, h5, h6, ul{
        max-width: $maxwidth;
        margin-left: auto;
        margin-right: auto;
      }
      ul{
        padding-bottom: 1rem;
      }
      li{
        list-style: none;
        &::before{
          content: '\2015 '
        }
      }
      p{
        a{
          color: white;
          text-decoration: none;
          position: relative;
          border-bottom: 3px solid #e9008b;
          &:hover,
          &:active,
          &:focus {
            background: #ee3b71;
            color: #fff;
            text-shadow: none
          }
        }
      }
      &:first-child{
        p:first-child{
          text-indent: 0;
          &:first-letter {
            // color: #e4a612;
            float: left;
            text-transform: uppercase;
            font-weight: 900;
            font-family: 'Georgia';
            font-size: 6.6rem;
            text-transform: uppercase;
            line-height: 5.4rem;
            padding-top: 4px;
            padding-right: 8px;
            margin-left: -6px;
          }
        }
      }
    }
  }
  .columns{
    display: grid;
    $maxcols: 6;
    @for $i from 1 through $maxcols {
      &.columns-#{$i} {
        grid-template-columns: repeat($i, 1fr);
      }
    }
  }

  .heading{
    text-align: center;
    h2{
      @include fluid-type(360px,
        1440px,
        26px,
        64px);
      text-align: center;
      // text-shadow: 1px 1px 0px rgba(black, 0.9), 1px 2px 3px rgba(black, 0.2) ;
      color: white;
      font-family: 'LaTercera', sans-serif;
      text-transform: uppercase;
      letter-spacing: 1px;
    }
  }
</style>


